<!-- placeholder -->

<div class="h-[105px] xl:h-[90px] w-full"></div>

<!-- <div
  class="w-full glass fixed top-0 left-0 z-40 border-bottom h-[105px] xl:h-[90px]"
  [class]="hasActiveTemporaryPromotion() ? 'h-[calc(105px+44px)] xl:h-[calc(90px+44px)]' : ''"
>
  @if (hasActiveTemporaryPromotion()) {
    <app-top-banner />
  } -->

<div
  class="w-full backdrop-blur-md bg-[#0B0F17]/80 border-b border-white/10 fixed top-0 left-0 z-40 h-[105px] xl:h-[90px]"
>
  <app-content-container>
    <div class="py-3 flex items-center">
      <a [routerLink]="'/'">
        <img
          src="/images/logomark/logo-cd-symbol.svg"
          alt="Code Dimension Logo"
          class="w-[50px]"
        />
      </a>

      <nav class="hidden xl:inline-block ml-auto">
        @for (link of resolvedLinks(); track link.url) { @if (link.isExternal) {
        <a
          [class]="`btn btn-ghost mx-1 font-normal text-base ${link.cssClasses}`"
          [attr.data-testid]="'header-' + link.label | replaceWhitespaceWithHyphen"
          [href]="link.url"
        >
          {{ link.label }}
        </a>
        } @else {
        <a
          [class]="`btn btn-ghost mx-1 font-normal text-base ${link.cssClasses}`"
          [attr.data-testid]="'header-' + link.label | replaceWhitespaceWithHyphen"
          [routerLink]="link.url"
        >
          {{ link.label }}
        </a>
        } }
      </nav>

      <ng-container *zionBreakpointObserver="'mobile'">
        <button
          type="button"
          class="cursor-pointer ml-auto"
          data-testid="mobile-header-menu-btn"
          (click)="openMobileMenuModal()"
          aria-label="Abrir menu de navegação"
        >
          <svg lucideMenu class="w-8 h-8"></svg>
        </button>
      </ng-container>
    </div>
  </app-content-container>
</div>

<!-- <BannerAlert /> -->

@if (isMobileMenuModalOpen()) {
<div class="header fixed top-0 z-50 w-full h-full bg-base-100 pt-3">
  <app-content-container>
    <div class="flex">
      <img
        src="/images/logomark/logo-cd-symbol.svg"
        alt="Code Dimension Logo"
        class="w-[50px]"
      />

      <button
        type="button"
        class="cursor-pointer ml-auto"
        (click)="closeMobileMenuModal()"
        aria-label="Fechar menu de navegação"
      >
        <svg lucideX class="w-8 h-8"></svg>
      </button>
    </div>

    <nav class="flex flex-col items-center justify-center h-[calc(100%-44px)]">
      @for (link of links(); track link.url) { @if (link.url.startsWith('http'))
      {
      <a
        class="header-link"
        [href]="link.url"
        (click)="closeMobileMenuModal()"
        [attr.data-testid]="'mobile-header-' + link.label | replaceWhitespaceWithHyphen"
      >
        {{ link.label }}
      </a>
      } @else {
      <a
        class="header-link"
        [routerLink]="link.url"
        (click)="closeMobileMenuModal()"
        [attr.data-testid]="'mobile-header-' + link.label | replaceWhitespaceWithHyphen"
      >
        {{ link.label }}
      </a>
      } }
    </nav>
  </app-content-container>
</div>
}
